import type {
  CreditNoteDeleteRequestType,
  CreditNoteDeleteResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCreditNoteDelete = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CreditNoteDeleteRequestType) =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `credit-note/${data.id}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<CreditNoteDeleteResponseType>(response).data,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.CreditNote],
      });
    },
  });
};
